import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'


import Header from '../components/header'
import Footer from '../components/footer'
import './index.css'
import css from './index.module.css'

import favicon from '../images/favicon.png'
// import back from '../images/blue_fade_big.jpg'


const Layout = ({ children, data }) => {

  console.log(data)
  
  return(
  <div>
    <Helmet
      title={(data.site.siteMetadata.title)}
      meta={[
        // { name: 'description', content: 'Sample' },
        // { name: 'keywords', content: 'sample, something' },
      ]}
      link={[
        { rel: 'shortcut icon', type: 'image/png', href: `${favicon}` }
      ]}
    >
      <html lang="en" className={css.high}/>
    </Helmet>
    
    <div className={css.layoutGrid} style={{msGridRow: 1, msGridColumn: 1}}>
      <div>
        <Header siteTitle={data.site.siteMetadata.title} />
      </div>

    
      <div style={{msGridRow: 2, msGridColumn: 1}}>
        {children()}
      </div>
      <div style={{msGridRow: 3, msGridColumn: 1}}>
        <Footer />
      </div>
    </div>
  </div>
)


}

// Layout.propTypes = {
//   children: PropTypes.node.isRequired,
// }

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js